import React from "react";
import { Button, Icon } from "@elaniintc/goes-design-system";
import { GripHandle } from "@/components/ui/grip-handle";

interface SectionHeaderProps {
  showGrip?: boolean;
  gripProps?: React.HTMLAttributes<HTMLSpanElement>;
  showTrash?: boolean;
  onDelete?: () => void;
  sectionIndex?: number;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  showGrip = false,
  gripProps,
  showTrash = false,
  onDelete,
  sectionIndex = 0,
}) => (
  <div className="flex items-center min-h-10 mb-4 px-2">
    {showGrip && (
      <span className="mx-2 flex items-center" {...gripProps}>
        <GripHandle />
      </span>
    )}
    <div className="flex-1 flex items-center gap-3">
      <div className="flex-1 border-t border-neutral-quiet"></div>
      <span className="font-semibold text-sm text-on-disabled px-3 whitespace-nowrap">
        Sección {sectionIndex + 1}
      </span>
      <div className="flex-1 border-t border-neutral-quiet"></div>
    </div>
    {showTrash && (
      <Button
        variant="ghost"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          onDelete?.();
        }}
      >
        <Icon type="far" name="trash" size="sm" />
      </Button>
    )}
  </div>
);

export default SectionHeader;
